import { ExclamationCircleFilled } from '@ant-design/icons';
import { useModel } from '@umijs/max';
import { Modal } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';

const JUST_LOGGED_IN_KEY = 'wischoicer_just_logged_in';
const EXPIRY_WARNING_DAYS = 7;

const getDaysUntilExpiry = (expireAt?: string | null): number | null => {
  if (!expireAt) return null;
  const expiryDate = new Date(expireAt);
  if (Number.isNaN(expiryDate.getTime())) return null;
  const now = new Date();
  const diffMs = expiryDate.getTime() - now.getTime();
  return Math.ceil(diffMs / (1000 * 60 * 60 * 24));
};

const MembershipExpiryReminder: React.FC = () => {
  const { initialState } = useModel('@@initialState');
  const [modalVisible, setModalVisible] = useState(false);
  const [daysLeft, setDaysLeft] = useState<number | null>(null);

  const checkAndShowReminder = useCallback(() => {
    const justLoggedIn = sessionStorage.getItem(JUST_LOGGED_IN_KEY) === 'true';
    if (!justLoggedIn) return;

    const memberLevel = initialState?.currentUser?.memberLevel;
    if (!memberLevel || memberLevel === 'FREE') {
      sessionStorage.removeItem(JUST_LOGGED_IN_KEY);
      return;
    }

    const days = getDaysUntilExpiry(initialState?.currentUser?.memberExpireAt);
    if (days !== null && days > 0 && days <= EXPIRY_WARNING_DAYS) {
      setDaysLeft(days);
      setModalVisible(true);
    }

    sessionStorage.removeItem(JUST_LOGGED_IN_KEY);
  }, [
    initialState?.currentUser?.memberExpireAt,
    initialState?.currentUser?.memberLevel,
  ]);

  useEffect(() => {
    if (initialState?.currentUser) {
      checkAndShowReminder();
    }
  }, [initialState?.currentUser, checkAndShowReminder]);

  const handleClose = () => {
    setModalVisible(false);
  };

  return (
    <Modal
      open={modalVisible}
      onCancel={handleClose}
      footer={null}
      centered
      width={420}
    >
      <div style={{ padding: '16px 0', textAlign: 'center' }}>
        <ExclamationCircleFilled
          style={{ fontSize: 48, color: '#faad14', marginBottom: 16 }}
        />
        <p
          style={{
            fontSize: 18,
            fontWeight: 600,
            marginBottom: 8,
          }}
        >
          会员即将到期
        </p>
        <p style={{ fontSize: 14, color: 'rgba(0, 0, 0, 0.65)', margin: 0 }}>
          您的会员即将在
          <span style={{ color: '#ff4d4f', fontWeight: 600, margin: '0 4px' }}>
            {daysLeft}
          </span>
          天后过期，请及时续期
        </p>
      </div>
    </Modal>
  );
};

export default MembershipExpiryReminder;
